
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { BAIconsMixin, AuthMixin, MyCoachMixin, CoachRoutingMixin, MyTeamsMixin, VuetifyMixin, ShowcaseEventMixin, AppHostnameMixin} from '@/mixins';
import SideNavSectionTitle from './SideNavSectionTitle.vue';
import BestAthletesLogo from '../ui/BestAthletesLogo.vue';
import { TeamModel } from '@/models/team';
import * as Routes from '@/../types/constants/web_client_user.routes';
import { BAEventModel } from '@/models';
import { baEventApi } from '@/api/BAEventsApi';

@Component({
	components: { BestAthletesLogo, SideNavSectionTitle },
})
export default class CoachSideNav extends Mixins(BAIconsMixin, AuthMixin, MyTeamsMixin, VuetifyMixin, MyCoachMixin, CoachRoutingMixin, ShowcaseEventMixin, AppHostnameMixin){
	@Prop({ default: true, type: Boolean }) value: boolean;
	mini = false;
	listHome: boolean = false;
	listTeams: boolean = false;
	listAthletes: boolean = true;
	listRegistrations: boolean = true;
	listEvents: boolean = false;
	listShowcases: boolean = false;

	mounted() {
		this.loadEvents();
        this.loadCurrentShowcaseEvents();
	}

	get CreateTeamRoutes(): string{
		return Routes.TeamCreate
	}
	get TeamDashboardRoute(): string{
		return Routes.TeamDashboard;
	}
	get CentralScoutingRoute(): string{
		return Routes.CoachCentralScoutingDashboard;
	}
	get ConnectingRoute(): string{
		return Routes.CoachConnectWithAthletes;
	}
	get AthleteReportsRoute(): string{
		return Routes.CoachAthleteReportsSummary;
	}
	get ScoutingReportsRoute(): string{
		return Routes.CoachScoutingReportsSummary;
	}
	get GameReportsRoute(): string {
		return Routes.CoachGameReportsSummary;
	}

	CoachProfileRoute(CoachId: string){
		this.$router.push({ name: 'CoachProfile', params: { coachId: CoachId} })
	}

	/**
	* The router's authGuard prevents the app from loading before auth0 is ready but the SideNav is outside of the app's router-view
	* So we watch the auth instance's user property and do some setup once it stops being null.
	*/
	userProfileUnwatch: () => void;
	userProfileReady(): void{
		if(this.userProfileUnwatch) this.userProfileUnwatch();
		this.initMyTeams();
	}
	created(): void{
		this.userProfileUnwatch = this.$auth.$watch("$auth.user", user => {
			if(user !== null){
				this.userProfileReady();
			}
		});
	}

	expanded: boolean = false;
	numToShow = this.IsMobile? 1 : 3;

	get CoachTeams(): Array<TeamModel> {
		return this.MyTeamsSorted(this.MyCoachProfile?.teams);
	}
	get TeamsToShow(): TeamModel[] {
		if( this.CoachAppActive ) return this.ShowAllTeams? this.CoachTeams : this.CoachTeams.slice(0, this.numToShow);
		return this.ShowAllTeams? this.MyActiveTeams : this.MyActiveTeams.slice(0, this.numToShow);
	}

	get ShowAllTeams(): boolean {
		return this.NumTeams <= this.numToShow || this.expanded;
	}

	get ShowButtonMore(): boolean {
		return this.CoachTeams.length > this.numToShow && !this.expanded;
	}

	get ShowButtonLess(): boolean {
		return this.CoachTeams.length > this.numToShow && this.expanded;
	}

	events: Array<BAEventModel> = [];
	eventsLoaded: boolean = false;
	eventsLoading: boolean = false;
	async loadEvents() {
		this.eventsLoaded = false;
		this.eventsLoading = true;
		this.events = await baEventApi.findByCoachId(this.MyCoachId)
		this.eventsLoading = false;
		this.eventsLoaded = true;
	}
	get Events(): Array<BAEventModel> {
		return this.events.filter(e => !e.registration).sort((a,b) => +b.date - +a.date);
	}
	get HasEvents(): boolean {
		return this.IsNotEmpty(this.Events);
	}
	get Registrations(): Array<BAEventModel> {
		return this.events.filter(e => e.registration);
	}
	get HasRegistrations(): boolean {
		return this.IsNotEmpty(this.Registrations);
	}
	gotoEvent(eventId: string) {
		this.$router.push({
			name: Routes.CoachBAEventDetail,
			params: { eventId }
		}); 
	}
}
